function initializeAutocomplete() {
  var addressElements = document.querySelectorAll('.autocomplete-address');
  var zipCodeElements = document.querySelectorAll('.autocomplete-zip-code');

  Array.from(addressElements).forEach((element, index) => {
    var autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'], id: element.dataset['inputId'] });
    google.maps.event.addListener(autocomplete, 'place_changed', onPlaceChanged);
  });

  Array.from(zipCodeElements).forEach((element, index) => {
    var autocomplete = new google.maps.places.Autocomplete(element, { types: ['postal_code'], id: element.dataset['inputId'] });
    google.maps.event.addListener(autocomplete, 'place_changed', onPlaceChanged);
  });
}

function onPlaceChanged() {
  var place = this.getPlace();

  for (var i in place.address_components) {
    var component = place.address_components[i];

    for (var j in component.types) {
      // Some types are ["country", "political"]
      var type_element = document.getElementById(component.types[j] + '_' + this.id);

      if (type_element) {
        type_element.value = component.short_name;
      }
    }
  }
}

window.addEventListener('load', initializeAutocomplete)
